"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var PlaceStyles_1 = require("../../style/PlaceStyles");
var UIActionsContext_1 = require("../../uiActions/UIActionsContext");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var CertificationWidget_1 = require("../Certification/CertificationWidget");
var DataQualityWarningTables_1 = require("../DataQualityWarnings/DataQualityWarningTables");
var TableIcon_1 = require("../icons/TableIcon");
var PlacePageIconContainer_1 = require("../placePage/PlacePageIconContainer");
var TableauUser_1 = require("../TableauUser");
function TablePlacePageHeader(props) {
    var uiActions = React.useContext(UIActionsContext_1.UIActionsContext);
    var siteUrls = React.useContext(SiteUrlsContext_1.SiteUrlsContext);
    return (React.createElement(PlaceStyles_1.PlacePageHeader, null,
        React.createElement(PlaceStyles_1.PlacePageTitleContainer, null,
            React.createElement(PlacePageIconContainer_1.PlacePageIconContainer, { title: Localize_1.Messages.Table() },
                React.createElement(TableIcon_1.TableMastheadIcon, { isCertified: props.table.isCertified })),
            React.createElement(PlaceStyles_1.PlacePageMastheadContainer, null,
                React.createElement(PlaceStyles_1.PlacePageMastheadRowContainer, null,
                    React.createElement(PlaceStyles_1.PlacePageTitle, { title: props.table.name || undefined }, props.table.name),
                    React.createElement(PlaceStyles_1.PlacePageActionsMenu, null, uiActions.renderTablesActionMenu(props.table))),
                React.createElement(PlaceStyles_1.PlacePageMastheadRowContainer, null,
                    React.createElement(TableContact, { table: props.table, siteUrls: siteUrls }),
                    React.createElement(TableCertifier, { table: props.table, siteUrls: siteUrls }),
                    React.createElement(TableDataQualityWarningStatusChip, { table: props.table }))))));
}
exports.TablePlacePageHeader = TablePlacePageHeader;
function TableContact(props) {
    var contact = props.table.__typename === 'DatabaseTable' ? props.table.contact : null;
    return (React.createElement(PlaceStyles_1.PlaceHeaderMetadataItem, null,
        React.createElement(TableauUser_1.TableauUser, { siteUrls: props.siteUrls, tableauUser: contact || undefined, labelText: Localize_1.Messages.GridHeaderContact, fallbackUsernameText: Localize_1.Messages.None })));
}
function TableCertifier(props) {
    if (props.table.__typename !== 'DatabaseTable') {
        return null;
    }
    return (React.createElement(PlaceStyles_1.PlaceHeaderMetadataItem, null,
        React.createElement(CertificationWidget_1.CertificationWidget, { contentId: props.table.id, certification: props.table, siteUrls: props.siteUrls, renderUser: true, showExtractRefresh: false })));
}
function TableDataQualityWarningStatusChip(props) {
    if (props.table.__typename !== 'DatabaseTable') {
        return null;
    }
    return React.createElement(DataQualityWarningTables_1.QueryTableOwnAndUpstreamDataQualityWarnings, { nodeId: props.table.id });
}
//# sourceMappingURL=TablePlacePageHeader.js.map